<template>
  <div class="footer" id="footer-box">
    <div class="footer-main">
      <div class="footer-contact">
        <div class="footer-tit">联系我们</div>
        <div class="footer-name">商务合作</div>

        <div class="footer-name">
          <router-link :to="{ path: '/about/contact' }">联系地址</router-link>
        </div>

        <div class="footer-name">
          <router-link :to="{ path: '/service_ruzhu' }">服务商入驻</router-link>
        </div>
      </div>
      <div class="footer-service">
        <div class="footer-tit">服务与支持</div>
        <div class="footer-name">
          <router-link :to="{ path: '/about' }">关于我们</router-link>
        </div>
        <div class="footer-name">
          <router-link :to="{ path: '/help' }">常见问题</router-link>
        </div>
        <div class="footer-name">
          <router-link :to="{ path: '/download' }">手机APP</router-link>
        </div>
      </div>
      <div class="footer-ewm">
        <div class="footer-ewm-icon">
          <img src="../assets/img/qrcode_for_gh_3ac4516b140d_258.jpg" />
        </div>
        <div class="footer-ewm-text">关注聚师傅官方微信号</div>
      </div>
      <div class="footer-bottom">
        <div class="footer-name">
          客服热线：028-64967606（周一至周日 09:00-21:00）
        </div>
        <div class="footer-filing">
          <a href="https://beian.miit.gov.cn/" target="_blank">
            <p class="footer-explan">
              蜀ICP备19028872号-1
            </p>
          </a>

          <div class="footer-gongan">
            <p class="footer-explan">公安备案号：</p>

            <a
              target="_blank"
              href="https://beian.mps.gov.cn/#/query/webSearch?code=51012402001409"
              class="footer-gongan-link"
            >
              <img src="../assets/img/filing.png" />
              <p class="footer-explan">川公网安备51012402001409号</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    if (location.href.includes("/map")) {
      document.getElementById("footer-box").style.display = "none";
      document.body.style.overflow = "hidden";
      document.body.style.background = "transparent";
    } else {
      document.getElementById("footer-box").style.display = "block";
      document.body.style.overflow = "auto";
    }
  },
};
</script>

<style lang="scss">
@import "./_footer.scss";
</style>
